<template>
    <div class="page registration-page">
        <auth-landing-logo/>

        <div class="page-wrap">
            <img
                src="@/assets/authorization/human-sit.svg"
                class="page-login_image"
            />

            <div class="form-wrap">
                <div class="form-content">
                    <header-main>
                        {{ $t("components.authorization.registration.header") }}
                    </header-main>
                    <form
                        id="registration"
                        novalidate
                        @keydown.enter.prevent="registration"
                    >
                        <input-field
                            v-model="form.name"
                            type="text"
                            :class="'input-unrequired'"
                            :placeholder="$t('components.authorization.registration.name')"
                        />

                        <input-field
                            v-model="form.company"
                            type="text"
                            :class="'input-unrequired'"
                            :placeholder="$t('components.authorization.registration.company')"
                        />

                        <div
                            :class="[
                'input-wrap',
                { input_error: v$.form.email.$errors.length },
              ]"
                        >
                            <input-field
                                v-model="v$.form.email.$model"
                                type="email"
                                :placeholder="$t('components.authorization.mail')"
                            />
                        </div>
                        <div
                            class="input-errors"
                            :style="{ height: v$.form.email.$errors.length ? '14px' : 0 }"
                        >
              <span
                  v-for="(error, index) of v$.form.email.$errors"
                  :key="index"
              >
                {{ $t(`components.authorization.${error.$message}`) }}
              </span>
                        </div>

                        <div
                            :class="[
                'input-wrap',
                {
                  input_error: v$.form.password.$errors.length,
                },
              ]"
                        >
                            <input-field
                                v-model="v$.form.password.$model"
                                class="input-password"
                                :type="showPassword ? 'text' : 'password'"
                                :placeholder="$t('components.authorization.password')"
                            />

                            <button
                                class="input-password-icon"
                                @click.prevent="showPassword = !showPassword"
                            >
                                <i
                                    :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                                ></i>
                            </button>
                        </div>

                        <div
                            class="input-errors"
                            :style="{ height: v$.form.password.$errors.length ? '14px' : 0 }"
                        >
              <span
                  v-for="(error, index) of v$.form.password.$errors"
                  :key="index"
              >
                {{ $t(`components.authorization.${error.$message}`) }}
              </span>
                        </div>

                        <div
                            :class="[
                'input-wrap',
                {
                  input_error: v$.form.passwordConfirm.$errors.length,
                },
              ]"
                        >
                            <input-field
                                v-model="v$.form.passwordConfirm.$model"
                                class="input-password"
                                :type="showPasswordConfirm ? 'text' : 'password'"
                                :placeholder="
                  $t('components.authorization.registration.password_confirm')
                "
                            />

                            <button
                                class="input-password-icon"
                                @click.prevent="showPasswordConfirm = !showPasswordConfirm"
                            >
                                <i
                                    :class="
                    showPasswordConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'
                  "
                                ></i>
                            </button>
                        </div>

                        <div
                            class="input-errors"
                            :style="{
                height: v$.form.passwordConfirm.$errors.length ? '14px' : 0,
              }"
                        >
              <span
                  v-for="(error, index) of v$.form.passwordConfirm.$errors"
                  :key="index"
              >
                {{
                      $t(`components.authorization.registration.${error.$message}`)
                  }}
              </span>
                        </div>

                        <div class="form-subtitle">
                            <p class="form-tab">
                                {{ $t("components.authorization.registration.text") }}
                            </p>

                            <a href="/terms/privacy_policy.php" class="underlined-link">
                                {{ $t("components.authorization.registration.conf") }}
                            </a>

                            <p class="form-tab">
                                {{ $t("components.authorization.registration.tab") }}
                            </p>

                            <a href="/terms/user_agreement.php" class="underlined-link">
                                {{ $t("components.authorization.registration.link") }}
                            </a>
                        </div>
                    </form>

                    <button-loading
                        class="button_submit"
                        type="submit"
                        form="registration"
                        :loading="button.loading"
                        :disabled="button.disabled"
                        @click.prevent="registration"
                    >
                        {{ $t("components.authorization.registration.button") }}
                    </button-loading>

                    <router-link :to="{ name: 'SignIn' }" class="bottom-link">
                        {{ $t("components.authorization.registration.link1") }}
                    </router-link>

                    <LanguageSelect/>

                    <auth-landing-link/>
                </div>

                <img src="@/assets/authorization/wave.svg" class="wave"/>

                <img src="@/assets/authorization/ronm-bg.png" class="ronm-bg"/>

                <img src="@/assets/authorization/cilinder-bf.png" class="cilinder-bf"/>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import AuthLandingLogo from "@/components/Auth/AuthLandingLogo.vue";
import AuthLandingLink from "@/components/Auth/AuthLandingLink.vue";
import InputField from "@/components/Recurring/InputField.vue";
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import LanguageSelect from "@/components/Recurring/LanguageSelect.vue";
import ToastContent from "@/components/Recurring/ToastContent.vue";
import {trackRegistrationCompleted} from "@/analytics/tracking";

import {mapActions, mapGetters} from "vuex";
import {withProps, clearToasts} from "mosha-vue-toastify";

import useVuelidate from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    helpers,
} from "@vuelidate/validators";

import {isCookieSet, setCookie, getCookieValue} from "@/helpers/cookies";

export default {
    name: "RegistrationPage",

    components: {
        ButtonLoading,
        InputField,
        HeaderMain,
        AuthLandingLogo,
        AuthLandingLink,
        LanguageSelect,
        ToastContent,
    },

    setup() {
        return {v$: useVuelidate(), clearToasts};
    },

    data() {
        return {
            ref: null,
            showPassword: false,
            showPasswordConfirm: false,

            form: {
                name: "",
                company: "",
                email: "",
                password: "",
                passwordConfirm: "",
            },

            button: {
                loading: false,
                disabled: false,
            },
        };
    },

    validations() {
        return {
            form: {
                email: {
                    required: helpers.withMessage("required", required),
                    email: helpers.withMessage("email_invalid_error", email),
                },
                password: {
                    required: helpers.withMessage("required", required),
                    min: helpers.withMessage("password_min_length_error", minLength(6)),
                },
                passwordConfirm: {
                    sameAs: helpers.withMessage(
                        "password_not_match_error",
                        sameAs(this.form.password)
                    ),
                },
            },
        };
    },

    computed: {
        ...mapGetters("auth", ["getLanguage"]),
    },

    methods: {
        ...mapActions("auth", ["REGISTER"]),

        setBtnLoading() {
            if (this.button.loading) {
                this.button.loading = false;
                this.button.disabled = false;

                return;
            }

            this.button.loading = true;
            this.button.disabled = true;
        },

        setReferralLink(queryRef) {
            if (!queryRef) {
                this.getReferralLinkFromCookie();
            } else {
                this.ref = queryRef;
                setCookie("ref", queryRef, 604800);
            }
            return !!this.ref;
        },

        getReferralLinkFromCookie() {
            this.ref = isCookieSet("ref") ? getCookieValue("ref") : null;
            return this.ref;
        },

        async registration() {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) return;

            // formed data to send to the server
            const payload = {
                full_name: this.form.name,
                email: this.form.email,
                company_name: this.form.company,
                password: this.form.password,
                language: this.getLanguage,
            };

            // take referral link from cookie and send it to the server
            this.getReferralLinkFromCookie();
            if (this.ref) {
                payload.ref = this.ref;
            }
            // take params from query and send it to the server
            if (Object.keys(this.$route.query).length) {
                payload.params = JSON.stringify(this.$route.query);
            }

            this.setBtnLoading();

            await this.REGISTER(payload)
                .then(() => {
                    this.$moshaToast(
                        withProps(ToastContent, {
                            msg: this.$t("components.authorization.registration.toast"),
                            type: "success",
                        }),
                        {
                            hideProgressBar: true,
                        }
                    );
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        event: "registration_new_user",
                        email: this.form.email,
                    });

                    const params = new URLSearchParams(window.location.search)
                    const utmSource = params.get('utm_source')

                    trackRegistrationCompleted({
                        ...(utmSource && { utm_source: utmSource })
                    })

                    this.$router.push({name: "SignIn"});
                })
                .catch((error) => {
                    let toastMsg = this.$t(
                        "components.authorization.registration.toast_error"
                    );

                    let responseMsg = error?.response?.data?.description;

                    if (responseMsg === "email already registered") {
                        toastMsg = this.$t(
                            "components.authorization.registration.user_exists_error"
                        );
                    }

                    this.$moshaToast(
                        withProps(ToastContent, {
                            msg: toastMsg,
                            type: "error",
                        }),
                        {
                            hideProgressBar: true,
                            timeout: 10000,
                        }
                    );
                })
                .finally(() => this.setBtnLoading());
        },
    },
    mounted() {
        const refLink = this.$route.query?.ref;
        if (refLink) {
            this.setReferralLink(refLink);
        }
    },

    unmounted() {
        this.clearToasts();
    },
};
</script>

<style lang="scss" scoped>
@use "@/styles/pages/auth/auth.scss";

.button_submit {
    margin: 7px auto 22px;
}

.form-content {
    // min-height: the card grows with the "Go to the E-chat website" link instead of squeezing the button
    min-height: 620px;
    background: rgba(#ffffff, 0.67) !important;
}
</style>
